"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantFirstAvailableExcursionDate = void 0;
const dayjs = require("dayjs");
const __1 = require("..");
const getVariantFirstAvailableExcursionDate = (variant) => {
    if (!variant)
        return null;
    if (!variant.order_lines)
        return null;
    const first_date = (0, __1.getVariantFirstDate)(variant);
    const last_date = (0, __1.getVariantLastDate)(variant);
    if (!first_date || !last_date)
        return null;
    const first = dayjs(first_date);
    const last = dayjs(last_date);
    // Collect all golf dates
    const golfDates = variant.order_lines
        .filter((orderLine) => orderLine.type.toLowerCase() === "golf")
        .map((orderLine) => dayjs(orderLine.start_date).format("YYYY-MM-DD"));
    // Loop through days between first and last (exclusive of endpoints)
    let current = first.add(1, "day");
    while (current.isBefore(last, "day")) {
        const currentStr = current.format("YYYY-MM-DD");
        if (!golfDates.includes(currentStr)) {
            return currentStr; // Found first non-golf, non-arrival, non-departure date
        }
        current = current.add(1, "day");
    }
    // Fallback to first date if no valid excursion date found
    return first_date;
};
exports.getVariantFirstAvailableExcursionDate = getVariantFirstAvailableExcursionDate;
